// extracted by mini-css-extract-plugin
export default {"scroller":"ScrollingText_scroller__3TIoO","scrollText":"ScrollingText_scrollText__rweml"};